import * as React from "react";
import { Link } from "react-router-dom";
import { ROUTES } from "utils/constants";

const AppInvalid = (props) => {

  return (
    <div className="page-not-found">
      <div className="content">
        <div className="top-bar">
          <div className="container-fluid px-5">
            <div className="row align-items-center">
              <div className="col-5 col-sm-6">
                <Link to={"/" + ROUTES.LOGIN}><img src="/assets/images/cloud-logo-black.svg" alt="" className="img-fluid" /></Link>
              </div>
              <div className="col-7 col-sm-6 text-end">
                <Link to={"/" + ROUTES.LOGIN} className="px-2 links"> <img src="/assets/images/icons/home.png" alt="" className="me-1" />Home
                </Link>
                <a href="#" className="ps-2 links"> <img src="/assets/images/icons/headphones.png" alt=""
                  className="me-1" />Support</a>
              </div>
            </div>
          </div>
        </div>
        <div className="pagenot-found">
          <div className="col-md-6 mx-auto mb-5">
            <div className="pagenot-found-content">
              <h2 className="title-gradient">404</h2>
              <h5 className="">Page Not Found!</h5>
              <Link to={"/" + ROUTES.LOGIN} className="btn round-btn btn-blue mt-4">Go Home</Link>

            </div>
          </div>
          <img src="/assets/images/shapes/404.jpg" alt="" className="img-fluid bg-404" />

        </div>
        <div className="copy-right ">
          <div className="container-fluid px-lg-5">
            <div className="row align-items-center justify-content-between">
              <div className="col-xl-6 text-center text-xl-start">© Copyright CloudOne.2025. All rights reserved.</div>
              <div className="col-xl-6 text-center text-xl-end my-3 my-lg-0">
                <a href="#" className="me-2">Terms & Conditions</a> .
                <a href="#" className="mx-2">Privacy Policy</a>.
                <a href="#" className="ms-2">Cookies Policy</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppInvalid;
